import React, { useState } from 'react'
import config from '../../../config'
import calculateInitialExpansion from './expansion/calculateInitialExpansion'
import TreeNode from './TreeNode'

const defaultItemOr = (label, item) => ({
  label,
  items: [],
  ...item
})


const calculateTreeData = edges => {
  const originalData = config.sidebar.ignoreIndex
    ? edges.filter(({ node }) => node.fields.slug !== '/')
    : edges
  return originalData
    .map(({ node: { fields,frontmatter } }) => ({ 
        slug: fields.slug, 
        title: fields.title,
        order: frontmatter.order,
        container: frontmatter.container,
        hideInNavigation: frontmatter.hideInNavigation,
        expansionSettings: {
          defaultExpandedFrom: frontmatter?.defaultExpandedFrom ?? "",  
          defaultExpandedTo: frontmatter?.defaultExpandedTo ?? "",  
        }
      })
    )
    .reduce(
      (accu, { slug, title,order,container,hideInNavigation, expansionSettings }) => {
        const parts = slug.split('/').filter(x => x);
        accu = accu ?? {
          items:[],
          url: "/",
        }
        let currentNodePath = accu
        parts.forEach(part => {
          var node = currentNodePath.items.find(f => f.part == "/"+part)
          if(node){
            currentNodePath = node
          }else{
            const newNodeItem = {
              part: "/"+part,
              items: []
            }
            currentNodePath.items.push(newNodeItem)
            currentNodePath = newNodeItem
          }
        })
        currentNodePath.url = slug
        currentNodePath.title = title
        currentNodePath.order = order;
        currentNodePath.container = container;
        currentNodePath.expansionSettings = expansionSettings
        currentNodePath.hideInNavigation = hideInNavigation
        
        return accu
      },
      { items: [],url: "/" }
    )
}

const Tree = ({ location, edges }) => {
  const [treeData] = useState(() => calculateTreeData(edges))
  const [expansions,setExpansions] = useState(() => calculateInitialExpansion(location,treeData,edges))

  const isExpanded = (url) => {    
    return expansions[url]
  }

  const toggleExpanded = (url) => {
    const newArg = {
      [url]: expansions[url] == true ? false : true
    }
    const newObj = Object.assign({},expansions,newArg);
    setExpansions(newObj)
  }

  return (
    <TreeNode
      className={`${
        config.sidebar.frontLine ? 'showFrontLine' : 'hideFrontLine'
      } firstLevel`}
      {...treeData}
      toggleExpanded={toggleExpanded}
      isExpanded={isExpanded}
      location={location}
    />
  )
}

export default Tree
